import React from "react";
import { IconButton, Tooltip, Zoom } from "@material-ui/core";
import { Input } from "@material-ui/icons";

export const DetailButton = props => {
  const onClick = e => {
    e.stopPropagation();
    props?.onClick?.(props.record);

    if (props.onClickDisabled != true) {
      const path = props?.path ?? props?.resource ?? "";
      const win: any = window.open(`#/${path}/${props?.record?.id ?? ""}`, "_blank");
      win.focus();
    }
  };

  return (
    <IconButton {...props} style={{ width: 40 }} onClick={onClick}>
      <Tooltip TransitionComponent={Zoom} title="Detail">
        <Input />
      </Tooltip>
    </IconButton>
  );
};
export default DetailButton;
